import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Partners from '../components/Partners';
import News from '../components/News';
import ScholarshipForm from '../components/ScholarshipForm';

const HomePage = () => {
  return (
    <>
      <Hero />
      <Services />
      <Partners />
      <News />
      <ScholarshipForm />
    </>
  );
};

export default HomePage;
